// extracted by mini-css-extract-plugin
export default {"tableRow":"CalculatorsDetailTable_tableRow__C1AGZ","current":"CalculatorsDetailTable_current__RQx13","filtersRow":"CalculatorsDetailTable_filtersRow__bAqAS"};